export default __webpack_public_path__ + "static/land_homes-9d239013b99f0c72903f4586edf7abc4.png";